import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { UserMenuComponent } from 'app/layout/common/user-menu/user-menu.component';
import { ChangePasswordModule } from 'app/modules/auth/change-password/change-password.module';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    declarations: [
        UserMenuComponent
    ],
    imports     : [
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        SharedModule,
        ChangePasswordModule,
        MatDialogModule
    ],
    exports     : [
        UserMenuComponent
    ]
})
export class UserMenuModule
{
}
